import { render, staticRenderFns } from "./ResultsDropdown.vue?vue&type=template&id=21825b6e&scoped=true&"
import script from "./ResultsDropdown.vue?vue&type=script&lang=js&"
export * from "./ResultsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ResultsDropdown.vue?vue&type=style&index=0&id=21825b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21825b6e",
  null
  
)

export default component.exports